import useSWR from 'swr';
import { mapPartnersBalanceDtoToEntity } from '@entities/balance';
import { swrKeys } from '@shared/api/swr/keys';

const DEFAULT_LIMIT = 20;

type UseReferralOptions = {
  enabled?: boolean;
};

export const useReferral = (page = 1, limit = DEFAULT_LIMIT, options?: UseReferralOptions) => {
  const enabled = options?.enabled ?? true;
  const partnersCountKey = enabled ? swrKeys.referral.partnersCount() : null;
  const partnersBalanceKey = enabled ? swrKeys.referral.partnersBalance() : null;
  const partnersAccountingsKey = enabled ? swrKeys.referral.partnersAccountings({ page, limit }) : null;

  const {
    data: partnersCountData,
    isLoading: isCountLoading,
    error: countError,
    mutate: mutateCount,
  } = useSWR(partnersCountKey);
  const {
    data: partnersBalanceData,
    isLoading: isBalanceLoading,
    isValidating: isBalanceValidating,
    error: balanceError,
    mutate: mutateBalance,
  } = useSWR(partnersBalanceKey);
  const {
    data: accountingsData,
    isLoading: isAccountingsLoading,
    mutate: mutateAccountings,
    error: accountingsError,
  } = useSWR(partnersAccountingsKey);

  const mutateOverview = () => {
    void mutateCount();
    void mutateBalance();
  };

  const partnersBalance = partnersBalanceData
    ? mapPartnersBalanceDtoToEntity(partnersBalanceData)
    : null;

  return {
    partnersCount: partnersCountData?.count ?? 0,
    partnersBalance: partnersBalance?.totalBalance ?? 0,
    partnersReserved: partnersBalance?.reservedBalance ?? null,
    partnersAvailable: partnersBalance?.availableBalance ?? null,
    partnersAssetBalances: partnersBalance?.assetBalances ?? [],
    operations: accountingsData?.data ?? [],
    pagination: accountingsData?.pagination ?? { page, limit, total: 0 },
    isLoading: isCountLoading || isBalanceLoading || isAccountingsLoading,
    isOverviewLoading: isCountLoading || isBalanceLoading,
    isBalanceValidating,
    isAccountingsLoading,
    countError,
    balanceError,
    accountingsError,
    mutateOverview,
    mutateAccountings,
  };
};
